import { LegalOrgsService } from "./lib/services/legal_orgs_service";

export const legalOrgsService = new LegalOrgsService();

export type {
    ILegalBisGroup,
    ILegalBisUnit,
    TLegalCountryCode,
    ILegalOrgsListParams,
    ILegalOrgListItem,
    ILegalOrg,
    ILegalOrgBankDetail,
    ILegalOrgsService,
} from "./lib/types/legal_orgs_service_types";
